// src/features/landing/infrastructure/landingStaticRepository.js

/** @type {import("../domain/heroSlide").HeroSlide[]} */
const HERO_SLIDES = [
    {
        id: 1,
        title: "Rising Brokers",
        subtitle: "보험 인력 시장의 새로운 기준",
        description: "보험사와 GA, 그리고 GA 전문 인력이 모두 함께 성장하는 구조를 설계합니다.",
        buttonText: "라이징 브로커즈 소개",
        image: "/images/slide_11.png",
        targetId: "/about",
    },
    {
        id: 2,
        title: "세상의 모든 중개",
        subtitle: "프리미엄 보험 전문 헤드헌팅",
        description: "GA 매니저·총무 채용을 위한 검증된 인재풀과 체계적인 매칭 프로세스를 제공합니다.",
        buttonText: "제공 서비스 안내",
        image: "/images/landing_5.png",
        targetId: "/service",
    },
    {
        id: 3,
        title: "검증된 인재, 안정적인 정착",
        subtitle: "3개월 대체 인력 보장과 입사 후 적응 교육",
        description: "채용 이후의 정착과 성장까지 책임지는 파트너십을 지향합니다.",
        buttonText: "파트너십 문의",
        image: "/images/slide_12.png",
        targetId: "/contact",
    },
    {
        id: 4,
        title: "RB Bridge",
        subtitle: "보험 지사 양수도, 비공개로",
        description: "3억~20억 원 규모 소형 보험 지사의 양수도를 익명 등록부터 대면 클로징까지 중개합니다.",
        buttonText: "RB 브릿지 알아보기",
        image: "/images/slide_rb_bridge.svg",
        targetId: "/rb-bridge",
    },
];

// Repository 객체
export const landingRepository = {
    getHeroSlides() {
        return HERO_SLIDES;
    },
};
